import Modal from 'ps-components/Modal/Modal';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import ModalFooter from 'ps-components/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import React from 'react';

function ConfirmationModal({ onConfirm, onCancel, show, row, loading }) {
  return (
    <Modal onClose={onCancel} show={show}>
      <ModalHeader>
        <h3>Are You Sure?</h3>
      </ModalHeader>
      <ModalBody>{row?.first_names + ' ' + row?.last_name} will be promoted to superadmin status.</ModalBody>
      <ModalFooter
        cancelBtnClick={onCancel}
        submitBtnClick={onConfirm}
        submitBtnTxtName="Yes"
        saveButtonDisabled={loading}
        hideCancelButton={loading}
      />
    </Modal>
  );
}

export default ConfirmationModal;
